/** MI DOMINO - your camera / microphone in your nameplate (and on the WebRTC
 *  mesh when playing online). Camera and mic are INDEPENDENT: you can turn on
 *  the mic without the camera (audio-only), or the camera without touching an
 *  already-live mic. */
import { isPro, proUpsell } from '../economy/tienda';
import { L } from '../game/engine';
import { netAttachTracks } from '../net/table';
import { myStream, setMyStream } from '../state';
import { $ } from '../ui/dom';
import { log } from '../ui/feed';
import { LANG } from '../ui/i18n';

/** Toggle the camera (keeps the mic running if it is on). */
async function toggleCamera(): Promise<void> {
  const btnCam = $('btn-cam');
  const vid = $('vid0');
  const ms: any = myStream;
  const v = ms && ms.getVideoTracks()[0];
  if (v) {
    // camera OFF — stop only the video; keep the mic running if it's on
    ms.getVideoTracks().forEach((t: any) => { t.stop(); ms.removeTrack(t); });
    vid.srcObject = null;
    vid.style.display = 'none';
    btnCam.classList.remove('on');
    if (ms.getTracks().length === 0) setMyStream(null);
    log(L('Cámara apagada.', 'Camera off.'));
    return;
  }
  try {
    // add video; grab audio too only if we don't already have a live mic
    const needAudio = !(ms && ms.getAudioTracks()[0]);
    const s = await navigator.mediaDevices.getUserMedia({ video: true, audio: needAudio });
    if (ms) s.getTracks().forEach((t: any) => ms.addTrack(t));
    else setMyStream(s);
    vid.srcObject = myStream;
    vid.style.display = 'block';
    btnCam.classList.add('on');
    log(L('¡Cámara encendida! Ya estás en la mesa. 🎥', 'Camera on! You are at the table. 🎥'), true);
    netAttachTracks();
  } catch (e: any) {
    log(L('No se pudo abrir la cámara: ', 'Could not open the camera: ') + e.message, true);
    log(L('Consejo: la cámara/micrófono requieren HTTPS o localhost.', 'Tip: camera/microphone require HTTPS or localhost.'));
  }
}

/** Toggle the mic: mute/unmute a live one, or open an audio-only stream. */
async function toggleMic(): Promise<void> {
  const btnMic = $('btn-mic');
  const ms: any = myStream;
  // already have a mic → just mute / unmute
  const a = ms && ms.getAudioTracks()[0];
  if (a) {
    a.enabled = !a.enabled;
    btnMic.textContent = a.enabled ? '🎤' : '🔇';
    btnMic.classList.toggle('on', a.enabled);
    log(a.enabled ? L('Micrófono activado. 🎤', 'Microphone on. 🎤') : L('Micrófono silenciado. 🔇', 'Microphone muted. 🔇'));
    return;
  }
  // no mic yet → turn it on WITHOUT the camera (audio-only)
  try {
    const s = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
    if (ms) s.getAudioTracks().forEach((t: any) => ms.addTrack(t));
    else setMyStream(s);
    btnMic.textContent = '🎤';
    btnMic.classList.add('on');
    log(L('¡Micrófono encendido! (sin cámara) 🎤', 'Microphone on! (no camera) 🎤'), true);
    netAttachTracks();
  } catch (e: any) {
    log(L('No se pudo abrir el micrófono: ', 'Could not open the microphone: ') + e.message, true);
    log(L('Consejo: el micrófono requiere HTTPS o localhost.', 'Tip: the microphone requires HTTPS or localhost.'));
  }
}

/** Wire 🎥 / 🎤 (needs #btn-cam, #btn-mic, #vid0 in the DOM). */
export function initCamera(): void {
  /* FREE tier: video at the table is a PRO privilege */
  $('btn-cam').onclick = () => {
    toggleCamera();
  };
  $('btn-mic').onclick = toggleMic;
}
